import { useDispatch } from 'react-redux';
import axiosInstance from './axiosinstance';
import { setUserPermissions } from '../../redux/slices/access/permissionSlice';

import { API_ENDPOINTS } from './urls';
import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp: number; // Expiration time (required to check if token is expired)
  iat?: number; // Issued at time (optional)
  sub?: string; // Subject (User ID or email)
  iss?: string; // Issuer (who issued the token)
  aud?: string; // Audience (who the token is intended for)
  role?: string; // Custom claim (e.g., user role)
}

export const handleGoogleLogin = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.GOOGLE_SIGN_URL,
      data,
    });
    localStorage.setItem('user', JSON.stringify(response.data.user));
    if (response.data.accessToken) {
      localStorage.setItem('accessToken', response.data.accessToken);
    }
    if (response.data.permissions) {
      localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
    }

    return response;
  } catch (error) {
    throw error;
  }
};
export const handleGoogleSignup = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.USER_SIGNUP,
      data,
    });

    return response;
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};

export const handleEmailLogin = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.CUSTOM_LOGIN,
      data,
    });

    localStorage.setItem('user', JSON.stringify(response.data.user));
    if (response.data.accessToken) {
      localStorage.setItem('accessToken', response.data.accessToken);
    }
    if (response.data.permissions) {
      localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export const signupEmail = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.USER_SIGNUP,
      data,
    });
    return response; // Response is already `response.data` from the interceptor
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};

export const isAuthenticated = () => {
  const accessTokenData = localStorage.getItem('accessToken');
  if (!accessTokenData) return false;

  try {
    const decoded = jwtDecode<JwtPayload>(accessTokenData);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
};
export const isRolesAllowed = (allowedRoles: string[]) => {
  // implement the logic to check if the user has any of the allowed roles
  const accessTokenData = localStorage.getItem('accessToken');
  if (!accessTokenData) return false;
  try {
    const decoded = jwtDecode<JwtPayload>(accessTokenData);
    const userRoles = decoded.role ? decoded.role.split(',') : [];
    const hasRole = userRoles.some((role) => allowedRoles.includes(role));
    return hasRole;
  } catch (error) {
    return false; // Consider invalid tokens as expired
  }
};

export const verifyEmail = async (token: string) => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: `${API_ENDPOINTS.VERIFY_EMAIL}/${token}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const google_sign_client_id =
  process.env.REACT_APP_GOOGLE_SIGNIN_CLIENT_ID;
